import * as React from "react";
import { SECTION_HEADER_CLASS } from "./section-header";
import { cn } from "@/lib/utils";

/**
 * Level 1 — the panel header (brief П0): the name of the tab (table, GM and player) or of the Подготовка rail, and on the
 * right ≤2 icons of the tab's own actions («⋯» counts). Pinned over the scroll, 40 px (icon 26 + 7 + 7), 12 px left, a
 * hairline under it across the whole width. Never folds. Section headers stick right under it (`--phead-h`).
 */
export function PanelHeader({
  title,
  actions,
  className,
  testid,
}: {
  readonly title: string;
  readonly actions?: React.ReactNode;
  readonly className?: string;
  readonly testid?: string;
}): React.JSX.Element {
  return (
    <div className={cn("phead", className)} data-testid={testid}>
      <h2 className={cn(SECTION_HEADER_CLASS, "min-w-0 flex-1 truncate")} title={title}>
        {title}
      </h2>
      {actions}
    </div>
  );
}

/** A tab body with its panel header: the header pins at the top, the sections stick under it. */
export function SidebarTab({
  title,
  actions,
  children,
  className,
  testid,
  headerTestid,
  tab,
}: {
  readonly title: string;
  readonly actions?: React.ReactNode;
  readonly children: React.ReactNode;
  readonly className?: string;
  readonly testid?: string;
  readonly headerTestid?: string;
  /** The sidebar tab it is (data-tab): what a test or a screen reader tool finds the tab by. */
  readonly tab?: string;
}): React.JSX.Element {
  return (
    <div className={cn("sidebar-tab", className)} data-testid={testid} data-tab={tab}>
      <PanelHeader title={title} actions={actions} testid={headerTestid} />
      {children}
    </div>
  );
}
